function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/** UI-only structural validation for expert-mode JSON editing. */

function validateScriptStructure(ast) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var errors = [];
  var forLocking = options.locking === true;
  if (ast === null || ast === undefined) {
    return {
      valid: false,
      errors: [{
        path: 'root',
        message: 'Script is missing'
      }]
    };
  }
  function walk(node, path) {
    if (!node || _typeof(node) !== 'object' || Array.isArray(node)) {
      errors.push({
        path: path,
        message: 'Expected script object'
      });
      return;
    }
    if (typeof node.op !== 'string' || node.op.length === 0) {
      errors.push({
        path: path,
        message: 'Missing or empty "op" field'
      });
      return;
    }
    var op = node.op.toLowerCase();
    if (op === 'and' || op === 'or' || op === 'not' || op === 'then') {
      if (!Array.isArray(node.args)) {
        errors.push({
          path: path,
          message: "\"".concat(node.op, "\" requires \"args\" array")
        });
        return;
      }
      if (op === 'not' && node.args.length !== 1) {
        errors.push({
          path: path,
          message: 'NOT requires exactly one argument'
        });
      }
      if ((op === 'and' || op === 'or') && node.args.length < 2) {
        errors.push({
          path: path,
          message: "\"".concat(node.op, "\" requires at least two arguments")
        });
      }
      if (op === 'then' && node.args.length < 2) {
        errors.push({
          path: path,
          message: 'THEN requires at least two phase arguments'
        });
      }
      for (var i = 0; i < node.args.length; i++) {
        walk(node.args[i], "".concat(path, ".args[").concat(i, "]"));
      }
      return;
    }
    if (node.args !== undefined) {
      errors.push({
        path: path,
        message: 'Leaf opcode must not have "args"'
      });
    }
    if (forLocking && node.witness !== undefined) {
      errors.push({
        path: path,
        message: '"witness" belongs on the test/unlocking script, not the locking script'
      });
    }
    if (node.witness != null && (_typeof(node.witness) !== 'object' || Array.isArray(node.witness))) {
      errors.push({
        path: path,
        message: '"witness" must be a plain object when present'
      });
    }
    if (node.required != null && (_typeof(node.required) !== 'object' || Array.isArray(node.required))) {
      errors.push({
        path: path,
        message: '"required" must be a plain object when present'
      });
    }
  }
  walk(ast, 'root');
  return {
    valid: errors.length === 0,
    errors: errors
  };
}
var _require = require('./script_build'),
  isPlaceholder = _require.isPlaceholder,
  placeholderMeta = _require.placeholderMeta,
  placeholderName = _require.placeholderName,
  collectWitnessMissing = _require.collectWitnessMissing,
  opcodeTreeNeedsWitness = _require.opcodeTreeNeedsWitness;
function pathKeyName(path) {
  if (!Array.isArray(path) || path.length === 0) {
    return '';
  }
  for (var i = path.length - 1; i >= 0; i -= 1) {
    var k = String(path[i]);
    if (!/^\d+$/.test(k)) {
      return k.toLowerCase();
    }
  }
  return String(path[path.length - 1]).toLowerCase();
}
function inferFieldKindFromPath(path) {
  if (!Array.isArray(path) || path.length === 0) {
    return 'text';
  }
  var k = pathKeyName(path);
  if (k === 'publickey' || k === 'publickeys') {
    return 'publickey';
  }
  if (k === 'signature' || k === 'signatures') {
    return 'signature';
  }
  if (k === 'hash') {
    return 'hash';
  }
  if (k === 'msg' || k === 'message') {
    return 'message';
  }
  if (k === 'm' || k === 'n' || k === 'threshold' || k === 'count') {
    return 'number';
  }
  if (k === 'op') {
    return 'logical';
  }
  return 'text';
}

/**
 * UI metadata for an existing field on the canonical script.
 * Does not invent fields — only interprets value + path already present on mod.script.
 */
function getFieldDefinition(value, path) {
  var pathArr = Array.isArray(path) ? path : String(path || '').split('.').filter(Boolean);
  var kind = 'text';
  var label = '';
  var hint = '';
  if (typeof value === 'string' && isPlaceholder(value)) {
    var meta = placeholderMeta(value);
    var tag = placeholderName(value);
    if ((meta === null || meta === void 0 ? void 0 : meta.action) === 'publickey') {
      kind = 'publickey';
    } else if ((meta === null || meta === void 0 ? void 0 : meta.action) === 'signature') {
      kind = 'signature';
    } else if ((meta === null || meta === void 0 ? void 0 : meta.action) === 'hash') {
      kind = 'hash';
    } else if (tag === 'msg' || tag === 'message') {
      kind = 'message';
    } else if (tag === 'and' || tag === 'or' || tag === 'not' || tag === 'then') {
      kind = 'logical';
    } else {
      kind = (meta === null || meta === void 0 ? void 0 : meta.action) === 'text' ? 'text' : (meta === null || meta === void 0 ? void 0 : meta.action) || 'text';
    }
    label = (meta === null || meta === void 0 ? void 0 : meta.label) || tag || 'Value';
    hint = (meta === null || meta === void 0 ? void 0 : meta.hint) || '';
  } else if (typeof value === 'number') {
    kind = 'number';
  } else {
    kind = inferFieldKindFromPath(pathArr);
  }
  if (pathArr.length && String(pathArr[pathArr.length - 1]).toLowerCase() === 'op' && typeof value === 'string') {
    var op = value.trim().toUpperCase();
    if (op === 'AND' || op === 'OR' || op === 'NOT' || op === 'THEN') {
      kind = 'logical';
    }
  }
  if (!label) {
    var leaf = pathArr.length ? String(pathArr[pathArr.length - 1]) : 'Value';
    label = leaf;
  }
  return {
    kind: kind,
    label: label,
    hint: hint,
    action: kind === 'message' ? 'text' : kind
  };
}
function resolveFieldOverlayKind(value, path) {
  return getFieldDefinition(value, path).kind;
}
function validateField(kind, value, app) {
  if (value === true || value === null || value === undefined) {
    return {
      valid: true,
      state: 'empty'
    };
  }
  var s = String(value).trim();
  if (!s || isPlaceholder(s)) {
    return {
      valid: true,
      state: 'empty'
    };
  }
  switch (kind) {
    case 'publickey':
      {
        var _app$crypto;
        var ok = (app === null || app === void 0 || (_app$crypto = app.crypto) === null || _app$crypto === void 0 ? void 0 : _app$crypto.isPublicKey) && app.crypto.isPublicKey(s) || /^[A-HJ-NP-Za-km-z1-9]+$/.test(s) && s.length >= 40 && s.length <= 50;
        return {
          valid: ok,
          state: ok ? 'valid' : 'warn',
          message: 'Expected a Saito public key'
        };
      }
    case 'hash':
      {
        var _ok = /^[0-9a-fA-F]{64}$/.test(s);
        return {
          valid: _ok,
          state: _ok ? 'valid' : 'warn',
          message: 'Expected 64-character hex hash'
        };
      }
    case 'signature':
      {
        var _ok2 = /^[0-9a-fA-F]+$/.test(s) && s.length >= 128;
        return {
          valid: _ok2,
          state: _ok2 ? 'valid' : 'warn',
          message: 'Expected hex signature bytes'
        };
      }
    case 'number':
      {
        var _ok3 = /^-?\d+$/.test(s);
        return {
          valid: _ok3,
          state: _ok3 ? 'valid' : 'warn',
          message: 'Expected an integer'
        };
      }
    default:
      return {
        valid: true,
        state: 'valid'
      };
  }
}
function isEmptyScript(script) {
  if (!script || _typeof(script) !== 'object' || Array.isArray(script)) {
    return true;
  }
  if (!script.op || String(script.op).trim() === '') {
    return true;
  }
  return false;
}
function collectPlaceholders(node) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var found = [];
  var skipRequired = options.skipRequired === true;
  var skipWitness = options.skipWitness === true;
  function walk(value, currentPath) {
    if (value === null || value === undefined) {
      return;
    }
    if (typeof value === 'string') {
      if (isPlaceholder(value)) {
        found.push(currentPath.join('.') || '(root)');
      }
      return;
    }
    if (Array.isArray(value)) {
      value.forEach(function (item, index) {
        walk(item, currentPath.concat(String(index)));
      });
      return;
    }
    if (_typeof(value) !== 'object') {
      return;
    }
    for (var _i = 0, _Object$keys = Object.keys(value); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (skipRequired && key === 'required') {
        continue;
      }
      if (skipWitness && key === 'witness') {
        continue;
      }
      walk(value[key], currentPath.concat(key));
    }
  }
  walk(node, path);
  return found;
}
function evaluateScriptStatus(lockingScript) {
  if (isEmptyScript(lockingScript)) {
    return {
      state: 'idle',
      placeholders: []
    };
  }
  var placeholders = collectPlaceholders(lockingScript, [], {
    skipRequired: true,
    skipWitness: true
  });
  var validation = validateScriptStructure(lockingScript);
  if (!validation.valid || placeholders.length > 0) {
    return {
      state: 'warn',
      placeholders: placeholders,
      validation: validation
    };
  }
  return {
    state: 'ready',
    placeholders: [],
    validation: validation
  };
}
function evaluateRequiredStatus(testScript, execution, opcodes) {
  if ((execution === null || execution === void 0 ? void 0 : execution.success) === true && opcodeTreeNeedsWitness(testScript, opcodes)) {
    return {
      state: 'ready',
      placeholders: []
    };
  }
  if (!opcodeTreeNeedsWitness(testScript, opcodes)) {
    return {
      state: 'idle',
      placeholders: []
    };
  }
  var missing = collectWitnessMissing(testScript, opcodes);
  if (missing.length > 0) {
    return {
      state: 'warn',
      placeholders: missing
    };
  }
  return {
    state: 'ready',
    placeholders: []
  };
}
function evaluateValidStatus(scriptStatus, requiredStatus, execution) {
  if (scriptStatus.state !== 'ready') {
    return {
      state: 'idle'
    };
  }
  if ((execution === null || execution === void 0 ? void 0 : execution.success) === true) {
    return {
      state: 'ready'
    };
  }
  if (requiredStatus.state !== 'ready') {
    return {
      state: 'warn'
    };
  }
  if (!execution || !execution.attempted) {
    return {
      state: 'warn'
    };
  }
  return {
    state: 'warn'
  };
}
function evaluateWorkspaceStatus(lockingScript, unlockingScript, execution, opcodes) {
  return {
    script: evaluateScriptStatus(lockingScript),
    required: evaluateRequiredStatus(unlockingScript, execution, opcodes),
    valid: evaluateValidStatus(evaluateScriptStatus(lockingScript), evaluateRequiredStatus(unlockingScript, execution, opcodes), execution)
  };
}

/** Witness stage is satisfied when the script needs no witness fields or all are filled. */
function isWitnessPhaseComplete(unlockingScript, opcodes) {
  if (!opcodeTreeNeedsWitness(unlockingScript, opcodes)) {
    return true;
  }
  return collectWitnessMissing(unlockingScript, opcodes).length === 0;
}

/**
 * Sequential workflow indicator — one derived phase, not three independent booleans.
 *
 * Phases: building_script → script_complete → witness_active → witness_complete
 *         → evaluation_success | evaluation_failed
 */
function deriveWorkflowIndicator(_ref) {
  var lockingScript = _ref.lockingScript,
    unlockingScript = _ref.unlockingScript,
    testingUnlocked = _ref.testingUnlocked,
    execution = _ref.execution,
    opcodes = _ref.opcodes,
    validationDisplay = _ref.validationDisplay;
  var idle = 'idle';
  var ready = 'ready';
  var warn = 'warn';
  var scriptReady = evaluateScriptStatus(lockingScript).state === 'ready';
  if (!scriptReady) {
    return {
      phase: 'building_script',
      script: idle,
      witness: idle,
      valid: idle,
      arrow1: idle,
      arrow2: idle
    };
  }
  if (!testingUnlocked) {
    return {
      phase: 'script_complete',
      script: ready,
      witness: idle,
      valid: idle,
      arrow1: idle,
      arrow2: idle
    };
  }
  if (!isWitnessPhaseComplete(unlockingScript, opcodes)) {
    return {
      phase: 'witness_active',
      script: ready,
      witness: warn,
      valid: idle,
      arrow1: ready,
      arrow2: idle
    };
  }
  var attempted = validationDisplay === 'valid' || validationDisplay === 'invalid' || validationDisplay === 'invalid_json' || (execution === null || execution === void 0 ? void 0 : execution.attempted) === true;
  if (!attempted) {
    return {
      phase: 'witness_complete',
      script: ready,
      witness: ready,
      valid: idle,
      arrow1: ready,
      arrow2: ready
    };
  }
  var success = validationDisplay === 'valid' || (execution === null || execution === void 0 ? void 0 : execution.success) === true;
  if (success) {
    return {
      phase: 'evaluation_success',
      script: ready,
      witness: ready,
      valid: ready,
      arrow1: ready,
      arrow2: ready
    };
  }
  return {
    phase: 'evaluation_failed',
    script: ready,
    witness: ready,
    valid: warn,
    arrow1: ready,
    arrow2: ready
  };
}
module.exports = {
  validateScriptStructure: validateScriptStructure,
  inferFieldKindFromPath: inferFieldKindFromPath,
  getFieldDefinition: getFieldDefinition,
  resolveFieldOverlayKind: resolveFieldOverlayKind,
  validateField: validateField,
  evaluateWorkspaceStatus: evaluateWorkspaceStatus,
  evaluateScriptStatus: evaluateScriptStatus,
  deriveWorkflowIndicator: deriveWorkflowIndicator,
  isWitnessPhaseComplete: isWitnessPhaseComplete,
  collectPlaceholders: collectPlaceholders,
  isEmptyScript: isEmptyScript
};